import { Radio } from 'lucide-react'
import type { WebModule } from '../core/index.js'
import type { MessagesAdminApi } from './adminApi.js'
import { DeliveryPage } from './admin/DeliveryPage.js'
import { WorkerMessagesTab } from './components/WorkerMessagesTab.js'
import { useWorkerBarriers } from './hooks.js'
import { MESSAGES_HELP_TOPICS } from './help.js'

/** The Messages tab's id, for a caller that opens a roster row straight onto it. */
export const MESSAGES_TAB = 'messages'

/** How many of this worker's notes nobody has marked seen yet: what the tab wears. */
function useUnseenNoteCount(workerId: string): number {
  return (useWorkerBarriers(workerId).data ?? []).filter((barrier) => barrier.acknowledgement === null).length
}

/** What the messages module contributes to the shells: an open roster row's Messages tab (this worker's notes, how they are reached, where their messages went) and the admin's System › Delivery page. */
export const messagesWebModule: WebModule<MessagesAdminApi> = {
  name: 'messages',
  adminPages: [{ path: '/admin/delivery', label: 'Delivery', title: 'Delivery beyond the app', icon: Radio, group: 'system', page: ({ api }) => <DeliveryPage api={api} /> }],
  rosterRowTabs: [{ key: MESSAGES_TAB, label: 'Messages', panel: ({ workerId, facilityId }) => <WorkerMessagesTab workerId={workerId} facilityId={facilityId} />, useBadge: useUnseenNoteCount }],
  helpTopics: MESSAGES_HELP_TOPICS,
}
